import React from 'react'


export default class extends React.Component {

  render() {
    let title = "Start met een gratis Trial";
    let text = "Gebruik alle functies gratis met de 14-dagen Trial, je hebt enkel een e-mail adres nodig om alle voordelen te ontdekken van Citrus.";
    let button = "Start Nu";
    if(this.props.lang === "EN") {
      title = "Start with a free trial";
      text = "Use all features for free with the 14-day trial, you only need an e-mail address to discover the benefits of Citrus.";
      button = "Start Now";
    }
    return (
      <div className="full big accent">
        <div className="wrap content-text">
          <h2 className="cta-title">{title}</h2>
          <p style={{textAlign:"center", opacity:".8"}}>{text}</p>
          {!this.props.link_to_start && <div style={{textAlign:"center"}}><button onClick={() => this.props.openModal("register")} className="btn btn-c btn-fat">{button}</button></div>}
          {this.props.link_to_start && <div style={{textAlign:"center"}}><a href="/start?register" className="btn btn-c btn-fat">{button}</a></div>}
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/StartFooterCTA.js